export default function Terms() {
  return (
    <div className="container__policy">
      <h1>Terms of Service</h1>
      <p>
        By using AI & Tech Today, you agree to use the content for informational purposes only.

We make no guarantees about accuracy, completeness, or outcomes from using information on this site.

All content is provided "as is" without warranties of any kind.

We reserve the right to update or modify these terms at any time.
      </p>
    </div>
  );
}